import type { JSX } from "preact";

interface BrutalModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
  children: JSX.Element | JSX.Element[];
  /** Optional max width class (e.g. max-w-xs, max-w-md). Default max-w-xs. */
  maxWidth?: string;
  /** Optional class for the title (e.g. for larger brutalist font). */
  titleClassName?: string;
}

export default function BrutalModal({
  open,
  onClose,
  title,
  children,
  maxWidth = "max-w-xs",
  titleClassName,
}: BrutalModalProps) {
  if (!open) return null;

  return (
    <div
      className="brutal-modal-overlay flex items-center justify-center"
      role="dialog"
      aria-modal="true"
      aria-labelledby="brutal-modal-title"
      onClick={onClose}
    >
      <div
        className={`border-2 border-black dark:border-gray-100 bg-white dark:bg-gray-950 p-4 w-[90%] flex flex-col gap-3 ${maxWidth}`}
        onClick={(e) => e.stopPropagation()}
      >
        <div
          id="brutal-modal-title"
          className={titleClassName ?? "text-sm font-semibold text-gray-900 dark:text-gray-100"}
        >
          {title}
        </div>
        {children}
      </div>
    </div>
  );
}
